<template>
  <section class="home-banner banner-wrapper">
    <div class="row banner">
      <div class="columns small-12 medium-6">
        <h1 class="only-mobile">
          Loteria
        </h1>
        <h1 v-if="exchangeEnded" class="h1-exchange-ended">
          Wymiana kapsli/zawleczek <br />
          została zakończona <br />
          w&nbsp;dniu <strong>05.09.2026&nbsp;r.</strong>
        </h1>
        <template v-else>
          <h1 class="only-desktop">
            Startujemy <br />
            <strong>30.12.2025</strong>
          </h1>
          <p class="bold only-desktop">
            Wymieniaj kapsle i zawleczki na <br />
            kolejne piwa Królewskie.
          </p>
        </template>
        <img src="images/2026/banner_win.svg" alt="Wygraj 4-pak lub piwo" class="before-mask win-image" />
      </div>
      <div class="columns small-12 medium-6 text-right relative">
        <img src="images/2026/4pak-piwo.png" alt="Obrazek prezentuje czteropak i butelkę piwa" class="piwa-image" />
        <img src="images/2026/kapsle.png" alt="Obrazek prezentuje zwycięskie kapsle" class="before-mask kapsle-image" />
      </div>
    </div>
    <div class="row align-center">
      <div class="column column-button">
        <Button href="#zasady" class="before-mask" variant="with-arrow">Poznaj zasady</Button>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components_2026/common/Button.vue'
import { isExchangeEnded } from '@/components_2026/exchangeEnded'

export default {
  name: 'BannerMain',
  components: {
    Button
  },
  data() {
    return {
      exchangeEnded: isExchangeEnded()
    }
  }
}
</script>

<style lang="scss" scoped>
.home-banner {
  .banner {
    @include media-up(md) {
      padding-left: 1rem;
    }
  }

  h1 {
    margin-left: 0;
    font-size: rem-calc(50);

    @include media-up(md) {
      font-size: rem-calc(62);
      text-transform: capitalize;
    }

    strong {
      color: #d7b56a;
    }

    &.h1-exchange-ended {
      text-transform: none;
      font-size: rem-calc(26);

      @include media-up(md) {
        font-size: rem-calc(40);
      }
    }
  }

  .win-image {
    max-width: 465px;
    width: 90%;

    @include breakpoint(small only) {
      margin-top: -1rem;
    }
  }

  .column-button {
    margin: 1.5rem auto;
    text-align: center;
  }

  .piwa-image {
    margin-top: -18%;
    width: 85%;

    @include breakpoint(medium) {
      margin-top: 2rem;
      width: 100%;
    }
  }

  .kapsle-image {
    position: absolute;
    bottom: 0;
    left: 20px;
    width: 33%;

    @include breakpoint(medium) {
      left: -50px;
      width: 40%;
    }
  }
}
</style>
